export enum TECHSTACK {
    REACT = "React.js",
    NEXT = "Next.js",
    TAILWIND = "Tailwind CSS",
    JEST = "Jest",
    TYPESCRIPT = "TypeScript",
    JAVASCRIPT = "JavaScript",
    PYTHON = "Python",
    DJANGO = "Django",
    REACTNATIVE = "React Native",
    FLUTTER = "Flutter",
    SWIFT = "Swift",
    JQUERY = "jQuery",
    RUST = "Rust",
    NODE = "Node.js",
    RUBY = "Ruby",
    RAILS = "Ruby on Rails",
    BOOSTRAP = "Bootstrap",
    MONGODB = "MongoDB",
    FIREBASE = "Firebase",
    PRISMA = "Prisma",
    KUBERNETES = "Kubernetes",
    GOLANG = "Go",
    POSTGRES = "PostgreSQL",
    DOCKER = "Docker",
    KAFKA = "Kafka",
    AWS = "AWS",
}
